import React from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import Button from '../Button';
import Input, { AddressInput, PhoneNumberInput } from '../Input';
import NewAccountScreenLayout from './NewAccountScreenLayout';

import step2Image from '../../assets/images/new-account/02.jpg';

const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const FORM_ID = 'new-account-step2-form';
const STORAGE_KEY = 'newAccount_businessOwner';

function getStoredValues() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

export default function BusinessOwnerInfo({
  initialValues = {},
  onNext,
  persistValues,
}) {
  const history = useHistory();
  const stored = getStoredValues();
  const initial = Object.keys(initialValues).length ? initialValues : stored;
  const [name, setName] = React.useState(initial.name || '');
  const [ownerName, setOwnerName] = React.useState(initial.ownerName || '');
  const [ownerEmail, setOwnerEmail] = React.useState(initial.ownerEmail || '');
  const [ownerPhoneNumber, setOwnerPhoneNumber] = React.useState(
    initial.ownerPhoneNumber || '',
  );
  const [address1, setAddress1] = React.useState(initial.address1 || '');
  const [address2, setAddress2] = React.useState(initial.address2 || '');
  const [city, setCity] = React.useState(initial.city || '');
  const [state, setState] = React.useState(initial.state || '');
  const [zip, setZip] = React.useState(initial.zip || '');

  const handleSubmit = (e) => {
    e.preventDefault();
    const values = {
      name,
      ownerName,
      ownerEmail,
      ownerPhoneNumber,
      address1,
      address2,
      city,
      state,
      zip,
    };
    try {
      sessionStorage.setItem('newAccount_businessOwner', JSON.stringify(values));
    } catch (err) {
      // ignore if sessionStorage unavailable
    }
    if (persistValues) persistValues(values);
    if (onNext) onNext(values);
    else history.push('/new-account/step/3');
  };

  const handleBack = () => {
    history.push('/new-account/step/1');
  };

  const footer = (
    <>
      <Button type="button" text="Back" onClick={handleBack} width="auto" />
      <Button
        margin="0"
        text="Next"
        type="button"
        onClick={() => document.getElementById(FORM_ID)?.requestSubmit()}
        width="auto"
      />
    </>
  );

  return (
    <NewAccountScreenLayout
      stepNumber={2}
      screenImageSrc={step2Image}
      title="Confirm Business Information"
      showSignInLink={false}
      footer={footer}
    >
      <Form id={FORM_ID} onSubmit={handleSubmit}>
        <Input
          type="text"
          header="BUSINESS NAME"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
          width="100%"
        />
        <Input
          type="text"
          header="OWNER NAME"
          value={ownerName}
          onChange={(e) => setOwnerName(e.target.value)}
          required
          width="100%"
        />
        <Input
          type="email"
          header="OWNER EMAIL"
          value={ownerEmail}
          onChange={(e) => setOwnerEmail(e.target.value)}
          required
          width="100%"
        />
        <PhoneNumberInput
          type="tel"
          header="OWNER PHONE NUMBER"
          value={ownerPhoneNumber}
          onChange={(e) => setOwnerPhoneNumber(e.target.value)}
          required
          width="100%"
        />
        <AddressInput
          header="ADDRESS"
          required
          address1Value={address1}
          address1OnChange={(e) => setAddress1(e.target.value)}
          address2Value={address2}
          address2OnChange={(e) => setAddress2(e.target.value)}
          cityValue={city}
          cityOnChange={(e) => setCity(e.target.value)}
          stateValue={state}
          stateOnChange={(e) => setState(e.target.value)}
          zipValue={zip}
          zipOnChange={(e) => setZip(e.target.value)}
          width="100%"
        />
      </Form>
    </NewAccountScreenLayout>
  );
}
